<div class="container-fluid">
  <!-- Tabela de Documentos -->
  <div class="row mt-4">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Lista de Documentos</h4>
        </div>
        <div class="card-body">
          <table datatable [dtOptions]="dtOptions" class="table table-striped table-bordered">
            <thead>
              <tr>
                <th>ID</th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Data de Vigência</th>
                <th>Arquivo</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let documento of documentos">
                <td>{{ documento.id }}</td>
                <td>{{ documento.nome }}</td>
                <td>{{ getTipoNome(documento.tipo) }}</td>
                <td>{{ documento.dataVigencia | date:'dd/MM/yyyy' }}</td>
                <td>{{ documento.arquivo }}</td>
                <td>
                  <span [class]="'badge ' + getStatusClass(documento.status)">
                    {{ documento.status }}
                  </span>
                </td>
                <td>               
                  <button class="btn btn-sm btn-info mr-1">
                    <i class="feather icon-download"></i>
                  </button>
                  <button class="btn btn-sm btn-warning mr-1" (click)="abrirModalCadastro()" title="Upload">
                    <i class="feather icon-upload"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Cadastro de Documento -->
<ng-template #modalCadastroDocumento>
  <div class="modal-header">
    <h5 class="modal-title">Cadastro de Documento</h5>
    <button type="button" class="close" (click)="modalRef.close()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <form [formGroup]="documentoForm" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="nome">Nome do Documento</label>
            <input type="text" class="form-control" id="nome" formControlName="nome">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="tipo">Tipo de Documento</label>
            <select class="form-control" id="tipo" formControlName="tipo">
              <option value="">Selecione...</option>
              <option *ngFor="let tipo of tiposDocumento" [value]="tipo.id">
                {{ tipo.nome }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="dataVigencia">Data de Vigência</label>
            <input type="date" class="form-control" id="dataVigencia" formControlName="dataVigencia">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="arquivo">Arquivo</label>
            <input type="file" class="form-control" id="arquivo" (change)="onFileSelected($event)">
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label for="descricao">Descrição</label>
            <textarea class="form-control" id="descricao" formControlName="descricao" rows="3"></textarea>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modalRef.close()">Cancelar</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="!documentoForm.valid">
      Salvar
    </button>
  </div>
</ng-template> 